import {
  VuexModule,
  Module,
  Action,
  getModule,
  Mutation,
} from "vuex-module-decorators";
import store from "./index";
import userService from "@/services/api/user.api";
import { UserInfo } from "@/types";

@Module({ dynamic: true, store, name: "user", namespaced: true })
class UserModule extends VuexModule {
  public userInfo: UserInfo | null = null;
  public hasAva = false;

  @Mutation
  setUserInfo(userInfo: UserInfo | null) {
    this.userInfo = userInfo;
  }

  @Mutation
  setHasAva(hasAva: boolean) {
    this.hasAva = hasAva;
  }

  @Action
  public async getUserInfo() {
    try {
      const res = await userService.getUserInfo();
      this.setUserInfo(res.data);
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  public async putUserInfo(userInfo: UserInfo) {
    try {
      await userService.putUserInfo(userInfo);
      this.setUserInfo(userInfo);
      return true;
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  public async getUserImage() {
    try {
      const res = await userService.getUserImage();
      return res.data;
    } catch (e) {
      console.error(e);
    }
  }

  @Action
  public async postUserImage(file: File) {
    try {
      await userService.postUserImage(file);
      return true;
    } catch (e) {
      console.error(e);
    }
  }
}

export default getModule(UserModule);
